<script>
  // @ts-check
  import ItemPreviewList from "$lib/components/ItemPreviewList.svelte";
  import {
    getPaginatedItemPreviewListItems,
    getThemedItemIds
  } from "$lib/utilities/contentTypes/itemPreviewList";
  // eslint-disable-next-line @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";

  const Constants = /** @type {const} */ ({
    pressReleasesPath: "/press-releases",
    maximumItemsInPressReleasesPage: 8
  });

  /** @type { string } */
  let className = "";
  export { className as class };

  export let data;
  export let itemsPerPage = 36;

  const urlPathName = $page?.url?.pathname;
  /** @type { () => number } */
  const getCurrentItemsPerPage = () => {
    if (
      urlPathName === `${Constants.pressReleasesPath}/` ||
      urlPathName === Constants.pressReleasesPath
    ) {
      return Constants.maximumItemsInPressReleasesPage;
    }
    return itemsPerPage;
  };

  // Tag automation gets the preference
  const isPopulatedByPathOrTag = !!data.fields?.itemsSource || !!data.fields?.pathQuery;
  const itemsData = isPopulatedByPathOrTag ? data.children : data.fields?.listItems;
  const itemsFormFactor = data.fields.itemsFormFactor;

  const themedItemIds = getThemedItemIds(data.fields?.themedItems);
  const featuredItems = data.fields?.featuredItems ?? [];
  const excludedItems = data.fields?.excludedItems ?? [];
  const sourceTagItemId = data.fields?.itemsSource ? data.fields?.itemsSource.sys?.id : null;

  const currentItemsPerPage = getCurrentItemsPerPage();

  const paginatedItems =
    getPaginatedItemPreviewListItems({
      itemsData,
      itemsFormFactor,
      themedItemIds,
      featuredItems,
      excludedItems,
      sourceTagItemId,
      itemsPerPage: currentItemsPerPage,
      isPopulatedByPathOrTag
    }) ?? [];
</script>

<ItemPreviewList class={className} {itemsFormFactor} items={paginatedItems} iplId={data.sys?.id} />
